module.exports = __webpack_public_path__ + "img/z.f5822e35.svg";